import React, { useEffect, useRef } from 'react';
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';
import gantt from 'dhtmlx-gantt';
import './Calendar.css';

const CampaignGantt = () => {
  const ganttContainer = useRef(null);

  useEffect(() => {
    // Attach Gantt to DOM
    gantt.init(ganttContainer.current);

    // Configure Gantt Chart Settings
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    gantt.config.start_date = new Date(currentYear, 0, 1); // January 1st of the current year
    gantt.config.end_date = new Date(currentYear, 11, 31); // December 31st of the current year
    gantt.config.scale_unit = 'month'; // Scale to days
    gantt.config.date_scale = '%M'; // Date format
    gantt.config.scale_unit = 'month';
    gantt.config.date_scale = '%M, %Y';
    gantt.config.subscales = [{ unit: 'month', step: 1, date: '%m' }];
    gantt.config.grid_width = 300; // Adjust left grid width
    gantt.config.row_height = 40; // Adjust row height for campaigns

    // Load Campaign Data
    gantt.clearAll();
    gantt.parse({
      data: [
        {
          id: 1,
          text: 'Spring Sale Campaign',
          start_date: '2025-02-20',
          duration: 10,
          progress: 0.4,
        },
        {
          id: 2,
          text: 'Eid Festival Promo',
          start_date: '2025-03-05',
          duration: 15,
          progress: 0.7,
        },
        {
          id: 3,
          text: 'Summer Clearance',
          start_date: '2025-04-01',
          duration: 20,
          progress: 0.3,
        },
      ],
    });

    return () => {
      gantt.clearAll();
    };
  }, []);

  return (
    <div ref={ganttContainer} style={{ width: '100%', height: '600px' }} />
  );
};

export default CampaignGantt;
